




































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputCode from "@/components/common/input/InputCode.vue";
import requestService from "@/service/requestService";
import { CarSelectData } from "@/model/CarSelection";
import { ElButton } from "element-ui/types/button";
import { Getter, Action } from "vuex-class";
import { kbnSkn } from "@/model/kbnSkn";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import ReservationDetailState from "@/store/reservation/state";
import * as util from "@/service/util";
import { CustomerService } from "@/service/CustomerService";
import { KANA_INDEX } from "@/model/KANA_INDEX";
import { inspectService } from "@/service/inspectService.ts";
import TireDialog from "@/components/tireDialog.vue";
@Component({
  components: {
    InputNumber,
    InputCode,
    SaveDialog,
    ConfirmDialog,
    TireDialog
  }
})
export default class carSelection extends Vue {
  $refs!: {
    btnRigister: ElButton;
    btnBrake: ElButton[];
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    inputSoukouKm: InputNumber;
    cancelDialog: ConfirmDialog;
    tireDialog: TireDialog;
    nyuukoErrorDialog: ConfirmDialog;
  };
  carForm: CarSelectData = {} as CarSelectData;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("currentState", { namespace: "CarSelection" })
  currentState: CarSelectData;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setState", { namespace: "CarSelection" })
  setState: any;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Action("updateMakerModel", { namespace: "ReservationDetail" })
  updateMakerModel: any;

  @Action("updateSoukouUnitKbn", { namespace: "CarSelection" })
  updateSoukouUnitKbn: any;
  @Action("updateSoukouBikouKbn", { namespace: "CarSelection" })
  updateSoukouBikouKbn: any;
  @Action("updateSoukouUnitKbn", { namespace: "ReservationDetail" })
  updateSoukouUnitKbnMD1: any;
  @Action("updateSoukouBikouKbn", { namespace: "ReservationDetail" })
  updateSoukouBikouKbnMD1: any;

  public reqService: requestService = new requestService();
  inspectService: inspectService = new inspectService();
  kbnTitles: string[] = [
    "skn_youto",
    "skn_kudou_houshiki",
    "skn_fuel_kbn",
    "skn_shift_kbn",
    "skn_meter_panel_alert",
    "skn_brake",
    "skn_saitei_chijou_kou_kbn"
  ];
  kbnSkns: kbnSkn[][] = [[], [], [], [], [], [], []];
  kbnJidousha: any = [];
  errorMsg: string = "";
  listKakyuki: any = [];
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  shashuRenban: any = null;
  saveType: string = "";
  maker: string = "";
  model: string = "";
  customerService: CustomerService = new CustomerService();
  msgNodata: string = MESSAGE.NoData;
  msgBelowLastSoukou: string = MESSAGE.BelowLastSoukou;
  soukouBikouList: any = [];
  soukouUnitList: any = [];
  originalSoukouKm: number | null = 0;
  originalSoukouMile: number | null = 0;
  isExceed: boolean = false;
  tempKm: any = null;
  tempMile: any = null;
  tireForm: any = {};
  title: string = "";
  nyuukoErrorMsg: string = "";

  get uketsuke() {
    if (this.reservationState) {
      return this.reservationState.uketsuke;
    }
    return {};
  }

  get srMakerCd() {
    if (this.uketsuke && this.uketsuke.srMakerCd) {
      return this.uketsuke.srMakerCd;
    }
    return "";
  }

  get srModelCd() {
    if (this.uketsuke.srModelCd) {
      return this.uketsuke.srModelCd;
    }
    return "";
  }

  get srMakerNm() {
    if (this.uketsuke.srMakerNm) {
      return this.uketsuke.srMakerNm;
    }
    return "";
  }

  get srModelNm() {
    if (this.uketsuke.srModelNm) {
      return this.uketsuke.srModelNm;
    }
    return "";
  }

  public setForm(props: string, params: any) {
    this.carForm[props] = (params == this.carForm[props]
      ? ""
      : +params
    ).toString();
    if (props === "shiftKbn" && !this.carForm["shiftKbn"]) {
      this.carForm["shiftKbn"] = this.kbnSkns[3][0].kbnKey;
    }
    if (props === "kudouHoushiki" && !this.carForm["kudouHoushiki"]) {
      this.carForm["kudouHoushiki"] = this.kbnSkns[1][0].kbnKey.toString();
    }
    this.setState(this.carForm);
  }

  created() {
    this.$emit("onactivepage", this.$route.name);
    let kbn1 = this.reqService.getSoukouBikou().then(list => {
      this.soukouBikouList = list;
    });
    let kbn2 = this.reqService.getSoukouUnit().then(list => {
      this.soukouUnitList = list;
    });
    Promise.all([kbn1, kbn2]).then(() => this.setSoukouData());
    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );

    let promise = this.kbnTitles.map(async (kbn: string) => {
      return this.reqService.getKbnSkns(kbn);
    });
    Promise.all(promise).then((res: any) => {
      this.$set(this, "kbnSkns", res);
      this.getData();
    });
    this.getNyuukoInfo();
  }

  getData() {
    this.reqService
      .getCarSelection(this.uketsukeExtendsId)
      .then(
        (res: any) => {
          res.sknUketsukeExtendsId = this.uketsukeExtendsId;
          this.setState({ ...res, uketsukeCd: this.uketsukeCd });
          this.carForm = this.currentState;
          this.saveTempSoukou();
          this.setOriginalSoukou();
          this.setDefaultBtn();
          this.shashuRenban = this.carForm.shashuRenban;
          this.setProgressState({
            stateId: res.sknWorkProgressState,
            stateNm: res.sknWorkProgressStateNm
          });
        },
        (err: any) => {
          console.log(err);
        }
      )
      .catch(error => {
        console.log(error);
      });
  }

  async setSoukouData() {
    if (this.currentState.soukouBikouKbn) {
      this.carForm.soukouBikouKbn = +this.currentState.soukouBikouKbn;
    } else {
      this.carForm.soukouBikouKbn = +this.soukouBikouList[0].kbn;
    }
    if (this.currentState.soukouUnitKbn) {
      this.carForm.soukouUnitKbn = +this.currentState.soukouUnitKbn;
    } else {
      this.carForm.soukouUnitKbn = +this.soukouUnitList[0].kbn;
    }
    this.updateSoukouUnitKbn(this.carForm.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.carForm.soukouBikouKbn);
    this.updateSoukouUnitKbnMD1(this.carForm.soukouUnitKbn);
    this.updateSoukouBikouKbnMD1(this.carForm.soukouBikouKbn);
    try {
      if (this.carForm.soukouKm && !this.carForm.soukouMile) {
        await this.onFocusoutSoukouKm();
      } else if (this.carForm.soukouMile && !this.carForm.soukouKm) {
        await this.onFocusoutSoukouMile();
      }
    } catch (e) {
      console.log("error: cannot convert soukou");
    }
  }

  setOriginalSoukou() {
    const { soukouKm = 0, soukouMile = 0 } = this.carForm;
    this.originalSoukouKm = soukouKm;
    this.originalSoukouMile = soukouMile;
  }

  setDefaultBtn() {
    //set default button value in carForm variable
    if (!this.carForm["shiftKbn"]) {
      this.carForm["shiftKbn"] = this.kbnSkns[3][0].kbnKey;
    }
    if (!this.carForm["kudouHoushiki"]) {
      this.carForm["kudouHoushiki"] = this.kbnSkns[1][0].kbnKey.toString();
    }
  }

  activeKudouHoushiki(kbn: kbnSkn) {
    if (!this.carForm.kudouHoushiki) {
      return kbn.num == 1;
    } else {
      return +this.carForm.kudouHoushiki == kbn.kbnKey;
    }
  }

  activeShift(kbn: kbnSkn) {
    if (!this.carForm.shiftKbn) {
      return kbn.num == 1;
    } else {
      return +this.carForm.shiftKbn == kbn.kbnKey;
    }
  }

  onEnterRightTireNokorimizo(e: any) {
    setTimeout(() => {
      if (e.target) {
        e.target.blur();
      }
      if (this.carForm.brake) {
        this.$refs.btnBrake[this.carForm.brake - 1].$el.focus();
      }
    }, 100);
  }

  onFocusout() {
    this.setState(this.carForm);
  }

  saveTempSoukou() {
    this.tempKm = this.carForm.soukouKm;
    this.tempMile = this.carForm.soukouMile;
  }

  onExceedSoukou() {
    this.errorMsg = util.msgExceedSoukou(this.carForm.soukouUnitKbn);
    this.$refs.errorDialog.onOpen();
  }

  onCloseMsg() {
    if (this.isExceed) {
      this.isExceed = false;
      this.carForm.soukouKm = this.tempKm;
      this.carForm.soukouMile = this.tempMile;
    }
  }

  onFocusoutSoukouKm() {
    const tempKm: number = this.carForm.soukouKm ? +this.carForm.soukouKm : 0;
    this.isExceed = util.checkLimitSoukou(tempKm, this.carForm.soukouUnitKbn);
    if (this.isExceed) {
      this.onExceedSoukou();
    } else {
      if (tempKm) {
        let extend = this.reservationState.sknUketsukeExtends;
        if (extend.zenkaiSoukouKm && tempKm && tempKm < extend.zenkaiSoukouKm) {
          this.onZenkaiSoukouWarning();
        }
        this.reqService.convertMiles_Km(tempKm, "2").then((mile: any) => {
          if (mile) {
            this.carForm.soukouMile = mile.miles ? mile.miles : 0;
            this.saveTempSoukou();
          }
        });
      } else {
        this.carForm.soukouMile = 0;
      }
    }
  }

  onFocusoutSoukouMile() {
    const tempMile: number = this.carForm.soukouMile
      ? +this.carForm.soukouMile
      : 0;
    this.isExceed = util.checkLimitSoukou(tempMile, this.carForm.soukouUnitKbn);
    if (this.isExceed) {
      this.onExceedSoukou();
    } else {
      if (tempMile) {
        let extend = this.reservationState.sknUketsukeExtends;
        if (extend.zenkaiSoukouMile && tempMile && tempMile < extend.zenkaiSoukouMile) {
          this.onZenkaiSoukouWarning();
        }
        this.reqService.convertMiles_Km(tempMile, "1").then((km: any) => {
          if (km) {
            this.carForm.soukouKm = km.km ? km.km : 0;
            this.saveTempSoukou();
          }
        });
      } else {
        this.carForm.soukouKm = 0;
      }
    }
  }

  onFocusoutKatashiki() {
    // this.clearShashu();
    this.onFocusout();
  }

  save() {
    this.loading = true;
    let data = {
      ...this.carForm,
      uketsukeCd: this.uketsukeCd,
      shashuRenban: this.shashuRenban
    };
    this.setState(data);
    if (this.carForm.soukouKm) {
      let soukouKmAvg = util.calSoukouAvg(
        this.carForm.soukouKm,
        this.reservationState.sknUketsukeExtends,
        this.uketsuke
      );
      let soukouMileAvg = util.calSoukouMileAvg(
        this.carForm.soukouMile || 0,
        this.reservationState.sknUketsukeExtends,
        this.uketsuke
      );
      this.reqService.saveMileage(
        this.customerService.getPutParams({
          soukouKm: this.carForm.soukouKm,
          soukouKmAvg,
          soukouMile: this.carForm.soukouMile,
          soukouMileAvg,
          soukouUnitKbn: this.carForm.soukouUnitKbn,
          soukouBikouKbn: this.carForm.soukouBikouKbn
        })
      );
      this.originalSoukouKm = this.carForm.soukouKm || 0;
      this.originalSoukouMile = this.carForm.soukouMile || 0;
    }
    return this.reqService.saveCarSelection(data);
  }

  onSaveError(res: any) {
    this.loading = false;
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    this.saveProcess("save");
  }

  onRegister() {
    this.saveProcess("register");
  }

  registerCallback() {
    this.$emit("saveSpentTime");
    this.$emit("onregister", { pageName: this.$route.name });
  }

  saveCallback() {
    this.loading = false;
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  saveProcess(saveType: string) {
    this.save().then(
      res => {
        if (saveType == "save") {
          this.saveCallback();
        } else {
          this.registerCallback();
        }
      },
      (res: any) => {
        this.onSaveError(res);
      }
    );
  }

  getKakyuki(makerCd: string, modelCd: string) {
    this.reqService.getKakyuki(makerCd, modelCd).then(
      (res: any) => {
        if (res) {
          this.$set(this, "listKakyuki", res);
        }
      },
      (err: any) => {}
    );
  }

  get isRequired() {
    let goNext: boolean = true;
    if (this.carForm) {
      if (!this.carForm.jidoushaShubetsu) {
        goNext = false;
      }
      // if (!this.checkFTire) {
      //   goNext = false;
      // }
      // if (!this.checkRTire) {
      //   goNext = false;
      // }
      // if (!this.carForm.fLeftTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.fRightTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.rLeftTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.rRightTireNokorimizo) {
      //   goNext = false;
      // }
      // if (!this.carForm.katashikiShiteiNo) {
      //   goNext = false;
      // }
      // if (!this.carForm.ruibetsuKubunNo) {
      //   goNext = false;
      // }
      // if (!this.carForm.katashiki) {
      //   goNext = false;
      // }
      // if (!this.carForm.engineKatashiki) {
      //   goNext = false;
      // }
      if (!this.carForm.brake) {
        goNext = false;
      }
      if (!this.carForm.youto) {
        goNext = false;
      }
      if (!this.carForm.kudouHoushiki) {
        goNext = false;
      }
      if (!this.carForm.fuelKbn) {
        goNext = false;
      }
      if (!this.carForm.shiftKbn) {
        goNext = false;
      }
      if (!this.carForm.meterPanelAlert) {
        goNext = false;
      }
      // if (!this.checkSoukou) {
      //   goNext = false;
      // }
      if (!this.carForm.sknSaiteiChijouKou) {
        goNext = false;
      }
    }
    return !goNext;
  }

  get checkFTire() {
    if (
      this.carForm.fTireSizeWize &&
      (this.carForm.fTireSizeHenpei || this.carForm.fTireSizeSpeed) &&
      this.carForm.fTireSizeInchi &&
      (this.carForm.fTireSizeIndex || this.carForm.youto != 3)
    ) {
      return true;
    }
    return false;
  }
  get checkRTire() {
    if (
      this.carForm.rTireSizeWize &&
      this.carForm.rTireSizeHenpei &&
      this.carForm.rTireSizeInchi &&
      (this.carForm.rTireSizeIndex || this.carForm.youto != 3)
    ) {
      return true;
    }
    return false;
  }

  get checkKatashiki() {
    if (
      this.carForm.katashiki &&
      this.carForm.engineKatashiki
      // && this.kakyukiKbn
    ) {
      return true;
    }
    return false;
  }

  setRTireFromFTire() {
    this.carForm.rTireSizeWize = this.carForm.fTireSizeWize;
    this.carForm.rTireSizeHenpei = this.carForm.fTireSizeHenpei;
    this.carForm.rTireSizeInchi = this.carForm.fTireSizeInchi;
    this.carForm.rTireSizeIndex = this.carForm.fTireSizeIndex;
    this.carForm.rTireSizePlyRating = this.carForm.fTireSizePlyRating;
    this.carForm.rTireSizeRadial = this.carForm.fTireSizeRadial;
    this.carForm.rTireSizeSpeed = this.carForm.fTireSizeSpeed;
    this.$set(this.carForm, "rTireSizeInput", this.carForm.fTireSizeInput);
  }

  onEnterSoukoukm() {
    this.$refs.inputSoukouKm.blur();
  }

  get checkSoukou() {
    if (this.reservationState && this.reservationState.sknUketsukeExtends) {
      let extend = this.reservationState.sknUketsukeExtends;
      if (extend.zenkaiSoukouKm) {
        if (
          extend.zenkaiSoukouKm &&
          this.carForm.soukouKm &&
          extend.zenkaiSoukouKm < this.carForm.soukouKm
        ) {
          return true;
        }
      } else if (this.carForm.soukouKm) {
        return true;
      }
    }
    return false;
  }

  get showToolTip() {
    if (this.reservationState && this.reservationState.sknUketsukeExtends) {
      let extend = this.reservationState.sknUketsukeExtends;
      // if (
      //   extend.zenkaiSoukouKm &&
      //   this.carForm.soukouKm &&
      //   this.carForm.soukouKm < extend.zenkaiSoukouKm
      // ) {
      //   return true;
      // }
    }
    return false;
  }

  changeSoukouUnit() {
    this.updateSoukouUnitKbn(this.carForm.soukouUnitKbn);
    this.updateSoukouUnitKbnMD1(this.carForm.soukouUnitKbn);
    this.reqService.saveMileage(
      this.customerService.getPutParams({
        soukouKm: this.originalSoukouKm,
        soukouMile: this.originalSoukouMile,
        soukouUnitKbn: this.carForm.soukouUnitKbn,
        soukouBikouKbn: this.carForm.soukouBikouKbn
      })
    );
  }

  changeSoukouBikou() {
    this.updateSoukouBikouKbn(this.carForm.soukouBikouKbn);
    this.updateSoukouBikouKbnMD1(this.carForm.soukouBikouKbn);
    this.reqService.saveMileage(
      this.customerService.getPutParams({
        soukouKm: this.originalSoukouKm,
        soukouMile: this.originalSoukouMile,
        soukouUnitKbn: this.carForm.soukouUnitKbn,
        soukouBikouKbn: this.carForm.soukouBikouKbn
      })
    );
  }

  clickHibi(val: number, index: number) {
    this.inspectService.resetHibi(val, index, this.carForm);
  }

  onInputFLeftTire(e: any) {
    console.log("onInputFLeftTire => ", e);
    this.carForm.fRightTireNokorimizo = this.carForm.fLeftTireNokorimizo;
  }

  onInputRLeftTire() {
    this.carForm.rRightTireNokorimizo = this.carForm.rLeftTireNokorimizo;
  }

  beforeDestroy() {
    this.carForm.soukouKm = this.originalSoukouKm;
    this.carForm.soukouMile = this.originalSoukouMile;
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  showTireDialog(isFront: boolean) {
    if (isFront) {
      this.tireForm = {
        isFront: isFront,
        wize: this.carForm.fTireSizeWize,
        henpei: this.carForm.fTireSizeHenpei
          ? this.carForm.fTireSizeHenpei
          : this.carForm.fTireSizeSpeed,
        radial: this.carForm.fTireSizeRadial,
        inchi: this.carForm.fTireSizeInchi,
        index: this.carForm.fTireSizeIndex,
        plyRating: this.carForm.fTireSizePlyRating,
        isKamotsu: this.carForm.youto == 3 ? true : false
      };
    } else {
      this.tireForm = {
        isFront: isFront,
        wize: this.carForm.rTireSizeWize,
        henpei: this.carForm.rTireSizeHenpei
          ? this.carForm.rTireSizeHenpei
          : this.carForm.rTireSizeSpeed,
        radial: this.carForm.rTireSizeRadial,
        inchi: this.carForm.rTireSizeInchi,
        index: this.carForm.rTireSizeIndex,
        plyRating: this.carForm.rTireSizePlyRating,
        isWTire: this.carForm.isWideTire,
        isKamotsu: this.carForm.youto == 3 ? true : false
      };
    }
    this.$refs.tireDialog.onOpen(this.tireForm);
  }

  setTireFrom(param: any) {
    if (this.tireForm.isFront) {
      this.carForm.fTireSizeWize = param.wize;
      this.carForm.fTireSizeRadial = param.radial;
      this.carForm.fTireSizeInchi = param.inchi;
      this.carForm.fTireSizeIndex = param.index;
      this.carForm.fTireSizePlyRating = param.plyRating;
      if (param.henpei === "S") {
        this.carForm.fTireSizeHenpei = null;
        this.carForm.fTireSizeSpeed = param.henpei;
      } else {
        this.carForm.fTireSizeHenpei = param.henpei;
        this.carForm.fTireSizeSpeed = null;
      }
      let fTireSizeInput = this.setTireSizeInput(param);
      this.$set(this.carForm, "fTireSizeInput", fTireSizeInput);
    } else {
      this.carForm.rTireSizeWize = param.wize;
      this.carForm.rTireSizeRadial = param.radial;
      this.carForm.rTireSizeInchi = param.inchi;
      this.carForm.rTireSizeIndex = param.index;
      this.carForm.rTireSizePlyRating = param.plyRating;
      if (param.henpei === "S") {
        this.carForm.rTireSizeHenpei = null;
        this.carForm.rTireSizeSpeed = param.henpei;
      } else {
        this.carForm.rTireSizeHenpei = param.henpei;
        this.carForm.rTireSizeSpeed = null;
      }
      this.carForm.isWideTire = param.isWTire;
      let rTireSizeInput = this.setTireSizeInput(param);
      this.$set(this.carForm, "rTireSizeInput", rTireSizeInput);
    }
  }

  setTireSizeInput(param: any): string {
    let str = "";
    if (param.radial === "R") {
      if (param.henpei === "S") {
        // 165SR14
        str =
          (param.wize ? param.wize.toString() : "") +
          (param.henpei ? param.henpei.toString() : "") +
          param.radial +
          param.inchi;
      }
      // 幅/扁平率,ラジアル,リム径 ex)185/55R16
      str =
        (param.wize ? param.wize.toString() : "") +
        "/" +
        (param.henpei ? param.henpei.toString() : "") +
        "/" +
        param.radial +
        param.inchi;
    } else {
      // バイアスタイヤ ex)5.60-13 4PR
      str = (param.wize ? param.wize.toString() : "") + "-" + param.inchi;
    }
    if (param.index && this.carForm.youto == 3)
      str += " " + param.index + param.plyRating;
    return str;
  }

  setTireSize(isFront: boolean) {
    let val = "";
    if (isFront) {
      val = this.carForm.fTireSizeInput ? this.carForm.fTireSizeInput : "";
    } else {
      val = this.carForm.rTireSizeInput ? this.carForm.rTireSizeInput : "";
    }
    if (val != "") {
      this.reqService.getTireSize(val).then(
        (res: any) => {
          if (res) {
            if (isFront) {
              this.carForm.fTireSizeWize = res.wize ? Number(res.wize) : null;
              this.carForm.fTireSizeHenpei = res.henpei
                ? Number(res.henpei)
                : null;
              this.carForm.fTireSizeInchi = res.inchi
                ? Number(res.inchi)
                : null;
              this.carForm.fTireSizeIndex = res.index
                ? Number(res.index)
                : null;
              this.carForm.fTireSizeRadial = res.radial;
              this.carForm.fTireSizeSpeed = res.speed;
              this.carForm.fTireSizePlyRating = res.plyRating;
            } else {
              this.carForm.rTireSizeWize = res.wize ? Number(res.wize) : null;
              this.carForm.rTireSizeHenpei = res.henpei
                ? Number(res.henpei)
                : null;
              this.carForm.rTireSizeInchi = res.inchi
                ? Number(res.inchi)
                : null;
              this.carForm.rTireSizeIndex = res.index
                ? Number(res.index)
                : null;
              this.carForm.rTireSizeRadial = res.radial;
              this.carForm.rTireSizeSpeed = res.speed;
              this.carForm.rTireSizePlyRating = res.plyRating;
            }
          }
        },
        (err: any) => {}
      );
    }
  }

  revertTireSize(isFront: boolean) {
    let data = {
      ...this.carForm,
      uketsukeCd: this.uketsukeCd,
      isFront: isFront.toString()
    };
    this.reqService.revertTireSize(data).then(
      (res: any) => {
        if (res.status != 204) {
          if (isFront) {
            this.$set(this.carForm, "fTireSizeInput", res.bodyText.toString());
          } else {
            this.$set(this.carForm, "rTireSizeInput", res.bodyText.toString());
          }
        }
      },
      (err: any) => {}
    );
  }

  onZenkaiSoukouWarning() {
    this.errorMsg = '前回走行距離よりも少ない数値が入力されました。問題なければこのまま進めてください。';
    this.$refs.errorDialog.onOpen();
  }

  getNyuukoInfo() {
    this.reqService.getNyuukoInfo(this.uketsukeExtendsId).then((res: any) => {
      if (res == true) {
        this.title = '【注意事項】';
        this.nyuukoErrorMsg = '前回入庫時から日数が経過しています。<br>再入庫の場合は、再度点検を行ってください。';
        this.$refs.nyuukoErrorDialog.onOpen();
      }
    });
  }

  onCloseNyuukoError() {
    this.title = '';
    this.nyuukoErrorMsg = '';
  }
}
